/*
 * MSCVTR — gedrag van de winkelwagen-lade, de cartpagina en het keuzevenster (Horizon-migratie, pakket 6).
 * Nieuw geschreven. Werkt samen met Horizon via Shopify's standaard-events:
 *  - Horizon's productformulier voegt toe en stuurt CartLinesUpdateEvent → wij verversen lade + pagina,
 *    en openen de lade bij 'add' (zoals in het oude thema: na toevoegen gaat de lade open);
 *  - eigen wijzigingen (aantal, verwijderen, suggestie toevoegen) gaan via /cart/*.js en daarna
 *    MSCVTR.verversWinkelwagen() (mscvtr-componenten.js), zodat ook Horizon's eigen onderdelen bijwerken.
 */
(() => {
  if (window.MSCVTR_WAGEN) return;
  window.MSCVTR_WAGEN = true;

  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const lade = () => document.getElementById('mscvtr-winkelwagen');
  const geld = (centen) => new Intl.NumberFormat('nl-NL', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(centen / 100);

  /* ── Verversen ─────────────────────────────────────────────────────────────── */
  const haalSecties = async (ids) => {
    const res = await fetch(`${root()}?sections=${ids.join(',')}`);
    if (!res.ok) throw new Error('secties');
    return res.json();
  };

  let bezig = null;
  const ververs = async () => {
    const ids = ['mscvtr-winkelwagen'];
    const pagina = document.querySelector('[data-mscvtr-cartpagina]');
    if (pagina && pagina.dataset.sectie) ids.push(pagina.dataset.sectie);
    const data = await haalSecties(ids);
    const parser = new DOMParser();

    const ladeHtml = data['mscvtr-winkelwagen'];
    const doel = document.querySelector('[data-mscvtr-wagen-inhoud]');
    if (ladeHtml && doel) {
      const nieuw = parser.parseFromString(ladeHtml, 'text/html').querySelector('[data-mscvtr-wagen-inhoud]');
      if (nieuw) {
        const focusRegel = document.activeElement?.closest?.('[data-mscvtr-regel]')?.dataset.key;
        const focusAantal = document.activeElement?.getAttribute?.('aria-label');
        doel.innerHTML = nieuw.innerHTML;
        if (focusRegel) {
          const terug = doel.querySelector(`[data-key="${focusRegel}"] [aria-label="${focusAantal}"]`) || doel.querySelector('.mscvtr-lade__sluit');
          terug?.focus({ preventScroll: true });
        }
      }
    }
    if (pagina && data[pagina.dataset.sectie]) {
      const nieuw = parser.parseFromString(data[pagina.dataset.sectie], 'text/html').querySelector('[data-mscvtr-cartpagina]');
      if (nieuw) pagina.replaceWith(nieuw);
    }
  };
  const verversVeilig = () => {
    bezig = (bezig || Promise.resolve()).then(ververs).catch(() => {}).finally(() => { bezig = null; });
    return bezig;
  };

  // Horizon (en onze eigen verversWinkelwagen) melden elke cart-wijziging met CartLinesUpdateEvent.
  import('@shopify/events').then(({ StandardEvents }) => {
    document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
      Promise.resolve(event.promise).then(async (uitkomst) => {
        await verversVeilig();
        const fout = uitkomst && uitkomst.detail && uitkomst.detail.didError;
        if (event.action === 'add' && !fout && !document.querySelector('[data-mscvtr-cartpagina]')) {
          const l = lade();
          if (l && !l.open) l.show();
        }
      }).catch(() => {});
    });
  }).catch(() => {
    document.addEventListener('cart:change', verversVeilig);
  });

  const wijzig = async (body, url = 'cart/change.js') => {
    const res = await fetch(`${root()}${url}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok) throw Object.assign(new Error(json.description || json.message || 'Fout'), { json });
    return json;
  };
  const meld = (tekst) => {
    if (window.MSCVTR && MSCVTR.verversWinkelwagen) return MSCVTR.verversWinkelwagen(tekst);
    return verversVeilig();
  };

  /* ── Aantal en verwijderen ─────────────────────────────────────────────────── */
  document.addEventListener('click', async (e) => {
    const knop = e.target.closest('[data-mscvtr-aantal]');
    if (!knop) return;
    const regel = knop.closest('[data-mscvtr-regel]');
    if (!regel) return;
    e.preventDefault();
    regel.setAttribute('aria-busy', 'true');
    try {
      await wijzig({ line: Number(regel.dataset.mscvtrRegel), quantity: Math.max(0, Number(knop.dataset.mscvtrAantal)) });
      await meld();
    } catch (err) {
      regel.removeAttribute('aria-busy');
      alert(err.message);
    }
  });

  /* ── Bestelnotitie ────────────────────────────────────────────────────────── */
  let notitieTimer = null;
  document.addEventListener('input', (e) => {
    if (!e.target.matches('[data-mscvtr-notitie]')) return;
    clearTimeout(notitieTimer);
    const waarde = e.target.value;
    notitieTimer = setTimeout(() => { wijzig({ note: waarde }, 'cart/update.js').catch(() => {}); }, 400);
  });

  /* ── Suggesties: één variant direct toevoegen ─────────────────────────────── */
  document.addEventListener('click', async (e) => {
    const knop = e.target.closest('[data-mscvtr-sugg-add]');
    if (!knop) return;
    knop.setAttribute('aria-busy', 'true');
    try {
      await wijzig({ id: Number(knop.dataset.mscvtrSuggAdd), quantity: 1 }, 'cart/add.js');
      await meld({ open: true });
    } catch (err) {
      alert(err.message);
    } finally {
      knop.removeAttribute('aria-busy');
    }
  });

  /* ── Keuzevenster (meer varianten) ────────────────────────────────────────── */
  const snelkoop = () => document.getElementById('mscvtr-snelkoop');
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  const vulSnelkoop = (product) => {
    const doel = snelkoop()?.querySelector('[data-mscvtr-snelkoop-inhoud]');
    if (!doel) return;
    const start = product.variants.find((v) => v.available) || product.variants[0];
    const keuze = [...start.options];
    const beeld = product.featured_image ? `${product.featured_image}${product.featured_image.includes('?') ? '&' : '?'}width=400` : '';
    doel.innerHTML = `
      <div class="mscvtr-snelkoop__product">
        ${beeld ? `<img src="${beeld}" alt="" class="mscvtr-snelkoop__beeld">` : ''}
        <div class="mscvtr-snelkoop__tekst">
          <span class="mscvtr-kaartmerk">${esc(product.vendor || '')}</span>
          <a href="${product.url}" class="mscvtr-snelkoop__titel">${esc(product.title)}</a>
          <span class="mscvtr-snelkoop__prijs" data-prijs></span>
        </div>
      </div>
      ${product.options.map((optie, i) => `
        <fieldset class="mscvtr-snelkoop__optie">
          <legend>${esc(optie.name)}: <span data-gekozen="${i}"></span></legend>
          <div class="mscvtr-snelkoop__waarden">
            ${optie.values.map((w) => `<button type="button" class="mscvtr-snelkoop__waarde" data-optie="${i}" data-waarde="${esc(w)}">${esc(w)}</button>`).join('')}
          </div>
        </fieldset>`).join('')}
      <p class="mscvtr-snelkoop__fout" data-fout hidden></p>
      <button type="button" class="mscvtr-wagen__knop mscvtr-snelkoop__toevoegen" data-snelkoop-toevoegen>Toevoegen</button>`;

    const variant = () => product.variants.find((v) => v.options.every((o, i) => o === keuze[i]));
    const werkBij = () => {
      const v = variant();
      doel.querySelectorAll('[data-gekozen]').forEach((s) => { s.textContent = keuze[Number(s.dataset.gekozen)]; });
      doel.querySelectorAll('.mscvtr-snelkoop__waarde').forEach((b) => {
        const i = Number(b.dataset.optie);
        b.setAttribute('aria-pressed', String(keuze[i] === b.dataset.waarde));
        const test = [...keuze]; test[i] = b.dataset.waarde;
        const kan = product.variants.some((x) => x.available && x.options.every((o, n) => o === test[n]));
        b.classList.toggle('is-uitverkocht', !kan);
      });
      doel.querySelector('[data-prijs]').textContent = v ? geld(v.price) : '';
      const knop = doel.querySelector('[data-snelkoop-toevoegen]');
      knop.disabled = !v || !v.available;
      knop.textContent = v && !v.available ? 'Uitverkocht' : 'Toevoegen';
    };
    doel.onclick = async (e) => {
      const w = e.target.closest('.mscvtr-snelkoop__waarde');
      if (w) { keuze[Number(w.dataset.optie)] = w.dataset.waarde; werkBij(); return; }
      const toe = e.target.closest('[data-snelkoop-toevoegen]');
      if (!toe) return;
      const v = variant();
      if (!v) return;
      toe.setAttribute('aria-busy', 'true');
      try {
        await wijzig({ id: v.id, quantity: 1 }, 'cart/add.js');
        await snelkoop().hide();
        await meld({ open: true });
      } catch (err) {
        const f = doel.querySelector('[data-fout]');
        f.textContent = err.message; f.hidden = false;
      } finally {
        toe.removeAttribute('aria-busy');
      }
    };
    werkBij();
  };

  document.addEventListener('click', async (e) => {
    const knop = e.target.closest('[data-mscvtr-snelkoop]');
    if (!knop) return;
    knop.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(`${root()}products/${encodeURIComponent(knop.dataset.mscvtrSnelkoop)}.js`);
      vulSnelkoop(await res.json());
      snelkoop()?.show(knop);
    } finally {
      knop.removeAttribute('aria-busy');
    }
  });
})();
